module.exports = __webpack_public_path__ + "img/lcTitle2.87a270ca.png";